import { Link, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import type {
  PolymorphicLinkProps,
  PolymorphicTypographyProps,
} from "../../types";

export const Heading = styled(Typography)<PolymorphicTypographyProps>(
  ({ theme }) => ({
  fontSize: 11,
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.5px",
  lineHeight: 1.3,
  margin: "0 0 18px",
  color: theme.palette.text.secondary,
}));

export const LinkItem = styled(Link)<PolymorphicLinkProps>(({ theme }) => ({
  display: "block",
  padding: 0,
  border: "none",
  background: "none",
  textAlign: "left",
  fontSize: 14,
  lineHeight: 1.35,
  marginBottom: 12,
  textDecoration: "none",
  cursor: "pointer",
  color: theme.palette.text.secondary,
  transition: theme.transitions.create("color", { duration: 160 }),
  "&:hover": {
    color: theme.palette.text.primary,
  },
}));